var _path, _g, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 51,
    viewBox: "0 0 96 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6799_90)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M91.2198 16.0314C93.8599 16.0314 96.0001 13.8912 96.0001 11.2511C96.0001 8.61097 93.8599 6.47073 91.2198 6.47073C88.5797 6.47073 86.4395 8.61097 86.4395 11.2511C86.4395 13.8912 88.5797 16.0314 91.2198 16.0314Z",
    fill: "url(#paint0_radial_6799_90)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6799_90",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: -1,
    width: 94,
    height: 53
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6799_90)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93.0341,
    height: 51.3708,
    transform: "translate(-1.07776 -0.00012207)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.987106 42.1061C1.05462 42.2229 3.13025 42.2379 5.19081 42.2153C7.25513 42.1965 9.31946 42.1174 11.38 42.0006C15.5011 41.7708 19.6147 41.3828 23.6982 40.8215C27.7816 40.2602 31.8387 39.5257 35.8543 38.6216C36.8564 38.3843 37.8622 38.1695 38.8567 37.9134L41.8401 37.1336C43.8141 36.561 45.7917 36.0073 47.7355 35.348L49.1971 34.8734C49.6831 34.7114 50.1652 34.5306 50.6474 34.3611C51.6118 34.0108 52.5837 33.683 53.5405 33.3139L56.3959 32.18C57.3489 31.8108 58.2756 31.3663 59.2174 30.9632L60.6225 30.3454C61.0858 30.1307 61.5454 29.9009 62.005 29.6787C62.9241 29.2266 63.8508 28.7972 64.7587 28.3263C66.5555 27.3544 68.375 26.4202 70.1116 25.3466C71.8896 24.3408 73.5697 23.1843 75.2762 22.0731C76.12 21.5005 76.9299 20.8865 77.7587 20.295L78.9942 19.3985C79.4011 19.0934 79.7891 18.7656 80.1884 18.4492L82.5767 16.5506L84.8633 14.5353L86.0047 13.5257L87.0933 12.4596L89.2707 10.3313L91.9566 12.9719C85.9256 18.9238 79.1336 24.0997 71.7465 28.1756C69.927 29.2417 68.0285 30.1609 66.1525 31.1177C65.207 31.5773 64.2426 31.9992 63.2858 32.4399C62.8074 32.6546 62.3327 32.8806 61.8505 33.0916L60.3927 33.6906C56.5202 35.3254 52.546 36.7079 48.5228 37.887C46.515 38.4973 44.4808 38.9983 42.4542 39.5181L39.3916 40.215C38.3707 40.4448 37.3423 40.6294 36.3177 40.8404C32.2116 41.6314 28.0754 42.2417 23.9204 42.6824C15.6141 43.5413 7.26267 43.8012 -1.07751 43.0968L-0.990873 42.1098L-0.987106 42.1061Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6799_90)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.537 51.3703H16.016L22.4651 27.2953C23.4709 23.5433 27.3284 20.4996 31.0803 20.4996H39.6013L33.1522 44.5746C32.1464 48.3265 28.2889 51.3703 24.537 51.3703ZM54.0629 44.5746L66.0081 -0.000549316H57.4871C53.7352 -0.000549316 49.8777 3.0432 48.8719 6.79515L36.9267 51.3703H45.4477C49.1997 51.3703 53.0571 48.3265 54.0629 44.5746ZM74.9774 44.5746L85.1107 6.74995H76.5897C72.8377 6.74995 68.9803 9.7937 67.9745 13.5457L57.8412 51.3703H66.3622C70.1142 51.3703 73.9716 48.3265 74.9774 44.5746Z",
    fill: "url(#paint1_linear_6799_90)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5333 30.0315L57.8112 51.3717H66.3322C70.0841 51.3717 73.9453 48.328 74.9473 44.576L81.8975 18.6325C76.311 23.2622 70.0352 27.0029 63.5333 30.0315ZM40.3096 38.6467L36.9005 51.3717H45.4214C49.1734 51.3717 53.0308 48.328 54.0366 44.576L56.9146 33.8325C51.298 35.8629 45.6738 37.4337 40.3096 38.6467ZM18.4044 42.3422L15.986 51.3717H24.5107C28.2589 51.3717 32.1201 48.328 33.1221 44.576L34.2522 40.372C28.1986 41.4042 22.7515 41.9994 18.4044 42.3459V42.3422Z",
    fill: "url(#paint2_linear_6799_90)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.5897 6.74995C72.8377 6.74995 68.9803 9.7937 67.9745 13.5419L57.8374 51.3665H59.2388L69.0142 14.8716C70.02 11.1235 73.8774 8.07971 77.6294 8.07971H84.7566L85.1107 6.74995H76.5897ZM57.4871 -0.000549316C53.7352 -0.000549316 49.874 3.03567 48.8719 6.79139L36.9267 51.3665H38.3205L49.9116 8.12491C50.9174 4.37296 54.7749 1.32921 58.5268 1.32921H65.654L66.0081 0.0032177H57.4871V-0.000549316ZM31.0765 20.4958C27.3246 20.4958 23.4672 23.5396 22.4614 27.2915L16.016 51.3628H17.4098L23.5086 28.6213C24.5106 24.8693 28.3718 21.8256 32.12 21.8256H39.251L39.6051 20.4958H31.0803H31.0765Z",
    fill: "url(#paint3_linear_6799_90)",
    style: {
      mixBlendMode: "screen"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.03655 42.602C7.24712 43.103 15.5685 42.6472 23.7881 41.6C27.8979 41.0688 31.9851 40.3644 36.0309 39.4867C37.0405 39.2569 38.0538 39.0497 39.0596 38.7973L42.0695 38.0364C44.0622 37.4789 46.0587 36.9364 48.0251 36.2847C51.9654 35.0303 55.8454 33.58 59.6125 31.8849L61.0326 31.2633C61.4997 31.0486 61.9631 30.815 62.4264 30.5928C63.3531 30.137 64.2873 29.7038 65.2065 29.2329C67.0222 28.2534 68.8605 27.3117 70.6159 26.2268C77.7431 22.0755 84.2299 16.8846 89.9407 10.9967L91.2818 12.319L88.9877 14.4662L87.8387 15.5398L86.6371 16.5531L84.2337 18.576L81.7324 20.4746C81.3143 20.791 80.9074 21.1149 80.4817 21.4201L79.1897 22.3091C78.327 22.8967 77.4794 23.507 76.6017 24.0758C74.8237 25.1758 73.0758 26.3172 71.2337 27.3042C69.4331 28.3589 67.5533 29.2743 65.6962 30.2198C64.7582 30.6756 63.8014 31.0938 62.8559 31.5308C62.3812 31.7455 61.9103 31.9677 61.4319 32.1749L59.9854 32.7701C59.0173 33.1581 58.068 33.5838 57.0886 33.9379L54.1578 35.0228C53.1784 35.3769 52.1839 35.6858 51.2007 36.0173C50.7072 36.1793 50.2137 36.3525 49.7165 36.5032L48.221 36.9515C46.2358 37.5731 44.2204 38.0854 42.2088 38.6165L39.1726 39.3323C38.1593 39.5696 37.1384 39.7617 36.1213 39.9764C32.0454 40.7939 27.9394 41.4342 23.8107 41.9051C19.6858 42.376 15.5383 42.6661 11.3908 42.7979C9.31522 42.8695 7.24336 42.8959 5.16773 42.8657C3.0921 42.8356 1.02024 42.7715 -1.04785 42.602H-1.03655Z",
    fill: "url(#paint4_linear_6799_90)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M91.2165 15.1504C93.3698 15.1504 95.1154 13.4048 95.1154 11.2515C95.1154 9.09824 93.3698 7.35266 91.2165 7.35266C89.0632 7.35266 87.3176 9.09824 87.3176 11.2515C87.3176 13.4048 89.0632 15.1504 91.2165 15.1504Z",
    fill: "url(#paint5_radial_6799_90)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2845 13.3072C94.4217 12.17 94.4217 10.3263 93.2845 9.18914C92.1473 8.05197 90.3036 8.05197 89.1664 9.18914C88.0293 10.3263 88.0293 12.17 89.1665 13.3072C90.3036 14.4444 92.1473 14.4444 93.2845 13.3072Z",
    fill: "url(#paint6_radial_6799_90)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6799_90",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.0106 7.95117) scale(10.9093 10.9093)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#1082FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1082FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6799_90",
    x1: 39.7444,
    y1: -1.77858,
    x2: 56.5529,
    y2: 46.1379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05193A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4B5D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6799_90",
    x1: 58.8848,
    y1: 70.5797,
    x2: 48.2015,
    y2: 32.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85A7E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05193A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6799_90",
    x1: 50.5596,
    y1: 54.8887,
    x2: 50.5596,
    y2: 5.26951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3273B4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05193A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6799_90",
    x1: -1.03655,
    y1: 26.935,
    x2: 91.2818,
    y2: 26.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1082FC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_6799_90",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.2295 8.55811) scale(8.8977 8.8977)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#1082FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1082FC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_6799_90",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.4836 9.23882) scale(6.64879)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#3273B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1082FC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6799_90"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 51,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6799_90"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93.0341,
    height: 51.3708,
    fill: "white",
    transform: "translate(-1.07776 -0.00012207)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.275dd31c1aec2ce05057525d8837856f.svg";
export { ForwardRef as ReactComponent };